// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-circle-loader[data-v-8271785e] {\n  stroke: #e5f5ef !important;\n}\n.green-color[data-v-8271785e] {\n  color: #2DB782;\n}\n[data-v-8271785e] .custom-input__extended .input-group .input-group-text {\n  background: #2DB782;\n  color: #fff;\n}", ""]);
// Exports
module.exports = exports;
